"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactMobileForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const webexUI_1 = require("webexUI");
const forms_service_ui_1 = require("@danfoss/forms-service-ui");
const forms_service_ui_mosaic_1 = require("@danfoss/forms-service-ui-mosaic");
const app_1 = require("app");
const ContactFormAnalyticsService_1 = require("./ContactFormAnalyticsService");
const ContactMobileForm = ({ formAlias, contactData, companyName, dictionary, formTitle, culture, formServiceUrl, onFormClose, }) => {
    const formRef = React.useRef(null);
    const [isSpinnerVisible, setIsSpinnerVisible] = React.useState(true);
    const [submitted, setSubmitted] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [formLoadFailed, setFormLoadFailed] = React.useState(false);
    React.useEffect(() => {
        formRef.current.focus();
    }, []);
    const hideSpinner = React.useCallback(() => {
        setIsSpinnerVisible(false);
    }, []);
    const getMessage = React.useCallback((dictionaryValue, errorValue) => {
        return errorValue ? ((0, jsx_runtime_1.jsx)("p", { children: dictionaryValue.submitErrorMessage })) : ((0, jsx_runtime_1.jsx)("span", { children: (0, app_1.StringToHTML)(dictionaryValue.submitSuccessMessage) }));
    }, []);
    const onFieldClick = React.useCallback((_event, field) => {
        const { type, url } = field;
        if (type === 'LinkButton') {
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackServiceProcessesRedirect(formAlias, formTitle, url);
        }
    }, [formAlias, formTitle]);
    const onFormSubmit = React.useCallback(() => {
        ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormSubmit(formAlias, formTitle);
    }, [formAlias, formTitle]);
    const onValidationError = React.useCallback((errors, isBackend) => {
        ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackValidationErrors(formAlias, formTitle, errors, isBackend);
    }, [formAlias, formTitle]);
    const handleFormClose = React.useCallback(() => {
        onFormClose();
        if (!submitted && !formLoadFailed) {
            ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormAbandon(formAlias, formTitle);
        }
    }, [formAlias, formLoadFailed, formTitle, onFormClose, submitted]);
    const onGenericError = React.useCallback(() => {
        setSubmitted(true);
        setError(true);
        ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackGenericFormError(formAlias, formTitle);
    }, [formAlias, formTitle]);
    const onSuccess = React.useCallback(() => {
        setSubmitted(true);
        setError(false);
        ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormSubmitSuccess(formAlias, formTitle);
    }, [formAlias, formTitle]);
    const onLoadFailed = React.useCallback(() => {
        setFormLoadFailed(true);
        setIsSpinnerVisible(false);
        ContactFormAnalyticsService_1.ContactFormAnalyticsService.trackFormLoadError(contactData.companyName);
    }, [contactData.companyName]);
    const formClassNames = React.useMemo(() => `contact-mobile-form ${submitted ? 'contact-mobile-form__submit-result' : ''}`, [submitted]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: formRef, className: formClassNames, tabIndex: -1, children: (0, jsx_runtime_1.jsxs)("div", { className: "contact-mobile-form__container", children: [(0, jsx_runtime_1.jsx)("div", { className: "contact-mobile-form__title", children: formTitle }), (0, jsx_runtime_1.jsx)("button", { className: "contact-mobile-form__close-button", onClick: handleFormClose, children: (0, jsx_runtime_1.jsx)("span", { className: "icon icon-cancel" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "contact-mobile-form__content", children: [isSpinnerVisible && ((0, jsx_runtime_1.jsx)("div", { className: "contact-mobile-form__spinner-wrapper", children: (0, jsx_runtime_1.jsx)(webexUI_1.Spinner, { visible: true }) })), !submitted ? ((0, jsx_runtime_1.jsx)(forms_service_ui_1.Form, { fieldComponentMap: forms_service_ui_mosaic_1.fieldComponentMap, culture: culture, formAlias: formAlias, apiDomain: formServiceUrl, onFieldClick: onFieldClick, onFormLoadSuccess: hideSpinner, onFormSubmit: onFormSubmit, onValidationError: onValidationError, additionalFormData: {
                                contactId: contactData.id,
                                contactName: companyName,
                            }, onSuccess: onSuccess, onGenericError: onGenericError, onFormLoadFailure: onLoadFailed, isPopup: false })) : ((0, jsx_runtime_1.jsx)("div", { className: "contact-mobile-form__submit-result", children: getMessage(dictionary, error) })), formLoadFailed && ((0, jsx_runtime_1.jsx)("p", { className: "contact-mobile-form__load-error", children: dictionary.genericErrorMessage }))] })] }) }));
};
exports.ContactMobileForm = ContactMobileForm;
